export const typeValues = ['fast', 'slow'];
export const orientationValues = ['top', 'bottom', 'left', 'right', 'top-left', 'top-right', 'bottom-left', 'bottom-right'];
export const textAlignValues = ['right', 'center', 'left'];
export const getPopOrientation = orientation => {
  if (orientation === 'top') {
    return 'top-center';
  }
  if (orientation === 'bottom') {
    return 'bottom-center';
  }
  if (orientation === 'left') {
    return 'center-left';
  }
  if (orientation === 'right') {
    return 'center-right';
  }
  return orientation;
};